import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';


@Component({

selector:'app-merchant-booking',

templateUrl:'./merchant-booking.component.html',

styleUrls:['./merchant-booking.component.scss']

})


export class MerchantBookingComponent implements OnInit {


merchantId:any;

bookings:any[]=[];
showServiceDetails = false;

selectedBooking: any = null;
currentFilter: string = 'All';
filterOptions: string[] = ['All', 'Pending Requests', 'Payment Pending', 'Advance Paid', 'Fully Paid'];

get filteredBookings() {
  if (this.currentFilter === 'All') {
    return this.bookings;
  }
  if (this.currentFilter === 'Pending Requests') {
    return this.bookings.filter(b => b.booking_status === 'Pending');
  }
  if (this.currentFilter === 'Payment Pending') {
    return this.bookings.filter(b => b.booking_status === 'Confirmed' && (!b.payment_status || b.payment_status === 'Pending'));
  }
  if (this.currentFilter === 'Advance Paid') {
    return this.bookings.filter(b => b.payment_status === 'Advance Paid');
  }
  if (this.currentFilter === 'Fully Paid') {
    return this.bookings.filter(b => b.payment_status === 'Paid');
  }
  return this.bookings;
}




constructor(
private apiService:ApiServiceService
){}



ngOnInit(){


this.merchantId =
localStorage.getItem('merchantId');


this.loadBookings();

}




loadBookings(){


this.apiService
.getMerchantBookings(this.merchantId)
.subscribe({

next:(res:any)=>{


console.log(
"BOOKING HISTORY",
res
);


this.bookings =
res.data || [];


},


error:(err)=>{

console.log(err);

}


});


}
openServiceDetails(booking:any){

this.selectedBooking = booking;

this.showServiceDetails = true;

}

closeServiceDetails(){

this.showServiceDetails = false;

}

  acceptBooking(booking: any) {
    Swal.fire({
      title: 'Accept Booking?',
      html: `Confirm booking for <b>${booking.service_name}</b> from <b>${booking.customer_name}</b>?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#16a34a',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, Accept',
      cancelButtonText: 'Cancel'
    }).then(result => {
      if (result.isConfirmed) {
        this.apiService.acceptBooking(booking._id).subscribe({
          next: (res: any) => {
            booking.booking_status = 'Confirmed';
            Swal.fire('Booking Confirmed!', 'The customer will be notified.', 'success');
          },
          error: (err: any) => {
            Swal.fire('Error', err.error?.message || 'Failed to accept booking', 'error');
          }
        });
      }
    });
  }

  rejectBooking(booking: any) {
    if (!booking.reject_reason || !booking.reject_reason.trim()) {
      Swal.fire('Error', 'Please provide a reason', 'warning');
      return;
    }
    this.apiService.rejectBooking(booking._id, booking.reject_reason).subscribe({
      next: (res: any) => {
        booking.booking_status = 'Rejected';
        booking.showReject = false;
        Swal.fire('Booking Declined', 'The customer has been notified', 'info');
      },
      error: (err: any) => {
        Swal.fire('Error', err.error?.message || 'Failed to decline booking', 'error');
      }
    });
  }

  markAdvancePaid(booking:any){

Swal.fire({

title:'Confirm Advance Payment',

text:`Mark ₹${booking.advance_amount} received from customer?`,

icon:'question',

showCancelButton:true,

confirmButtonText:'Yes, Received'

})
.then(result=>{


if(result.isConfirmed){


this.apiService
.markAdvancePaid(booking._id)
.subscribe({

next:(res:any)=>{


booking.payment_status =
"Advance Paid";


booking.paid_amount =
booking.advance_amount;


booking.pending_amount =
booking.total_amount -
booking.advance_amount;


Swal.fire(
"Updated",
"Advance payment marked",
"success"
);


},


error:(err)=>{

Swal.fire(
"Error",
err.error.message,
"error"
);

}


});


}


});


}

  markFullyPaid(booking: any) {
    if (booking.payment_status === 'Advance Paid') {
      // Just complete the remaining payment
      Swal.fire({
        title: 'Complete Payment?',
        text: 'Mark the remaining balance as fully paid?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#16a34a',
        confirmButtonText: 'Yes, Complete It'
      }).then((result) => {
        if (result.isConfirmed) {
          this.apiService.markFullyPaid(booking._id).subscribe({

next:(res:any)=>{

booking.payment_status = 'Paid';

booking.paid_amount =
booking.total_amount;

booking.pending_amount = 0;


Swal.fire(
'Success',
'Payment marked as fully completed.',
'success'
);

},


error:(err:any)=>{

Swal.fire(
'Error',
err.error?.message || 'Failed to complete payment',
'error'
);

}

});
        }
      });
    } else {
      // Direct full payment
      Swal.fire({
        title: 'Full Payment',
        text: `Mark this booking (₹${booking.price}) as fully paid?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#16a34a',
        confirmButtonText: 'Yes, Fully Paid'
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            bookingId: booking._id,
            merchantId: this.merchantId,
            customer_email: booking.customer_email,
            service_name: booking.service_name,
            total_amount: booking.price,
            payment_type: 'Full Payment',
            advance_amount: 0,
            remaining_amount: 0,
            payment_status: 'Paid'
          };
          this.apiService.markFullyPaid(booking._id).subscribe({
            next: () => {
              booking.payment_status = 'Paid';
              Swal.fire('Success', 'Full payment logged successfully.', 'success');
            },
            error: (err: any) => {
              Swal.fire('Error', err.error?.message || 'Failed to log payment', 'error');
            }
          });
        }
      });
    }
  }

  viewHistory(booking: any) {
    if (!booking.history || booking.history.length === 0) {
      Swal.fire('No History', 'No history logs found for this booking yet.', 'info');
      return;
    }

    let timelineHtml = '<div style="text-align: left; margin-top: 15px; padding-left: 20px; border-left: 2px solid #e5e7eb;">';
    
    booking.history.forEach((log: any) => {
      const date = new Date(log.timestamp).toLocaleString();
      let icon = 'history';
      let color = '#6b7280';
      
      if (log.action.includes('Requested')) { icon = 'add_circle'; color = '#3b82f6'; }
      if (log.action.includes('Accepted') || log.action.includes('Confirmed')) { icon = 'check_circle'; color = '#16a34a'; }
      if (log.action.includes('Advance')) { icon = 'payments'; color = '#f59e0b'; }
      if (log.action.includes('Fully Paid')) { icon = 'task_alt'; color = '#16a34a'; }
      if (log.action.includes('Rejected')) { icon = 'cancel'; color = '#ef4444'; }

      timelineHtml += `
        <div style="position: relative; margin-bottom: 25px;">
          <div style="position: absolute; left: -32px; background: white; border-radius: 50%; padding: 2px;">
            <span class="material-symbols-outlined" style="color: ${color}; font-size: 20px;">${icon}</span>
          </div>
          <h4 style="margin: 0 0 5px 0; font-size: 15px; font-weight: bold; color: #374151;">${log.action}</h4>
          <p style="margin: 0 0 4px 0; font-size: 13px; color: #4b5563;">${log.details || ''}</p>
          <span style="font-size: 11px; color: #9ca3af;">${date}</span>
        </div>
      `;
    });
    
    timelineHtml += '</div>';

    Swal.fire({
      title: 'Booking History',
      html: timelineHtml,
      showConfirmButton: true,
      confirmButtonText: 'Close',
      confirmButtonColor: '#B01E3E'
    });
  }

}